import { Crop, Hand, MousePointer2 } from "lucide-react";
import { useCallback } from "react";

import { trackImageEditToolCursorModeSelected } from "@design-lab/shared/lib/analytics";
import { ToggleGroup, ToggleGroupItem } from "@design-lab/shared/ui/toggleGroup";
import { type InteractionMode } from "@design-lab/entities/artwork";

type RefinModeSelectorProps = {
  value: InteractionMode;
  onValueChange: (mode: InteractionMode) => void;
};

export function RefineModeSelector({ value, onValueChange }: RefinModeSelectorProps) {
  const modes: Array<{ id: InteractionMode; icon: typeof MousePointer2; label: string }> = [
    { id: "cursor", icon: MousePointer2, label: "Cursor" },
    { id: "pan", icon: Hand, label: "Pan" },
    { id: "crop", icon: Crop, label: "Crop" }
  ];

  const handleValueChange = useCallback(
    (newValue: string | undefined) => {
      if (newValue) {
        const mode = newValue as InteractionMode;
        trackImageEditToolCursorModeSelected(mode);
        onValueChange(mode);
      }
    },
    [onValueChange]
  );

  return (
    <div className="bg-background flex items-center gap-1 rounded-md border p-1 shadow-sm">
      <ToggleGroup type="single" value={value} onValueChange={handleValueChange} size="sm">
        {modes.map(({ id, icon: Icon, label }) => (
          <ToggleGroupItem key={id} value={id} aria-label={label} data-testid={`refine-mode-${id}`}>
            <Icon className="size-5" />
          </ToggleGroupItem>
        ))}
      </ToggleGroup>
    </div>
  );
}
